import styled, { css } from 'styled-components';
import { SimpleButton } from './basic';
import { ButtonType } from '../../components/ui/Button';

export const ButtonLabel = styled.span`
	font-size: 18px;
`;

interface IButtonStyled {
	buttonType?: ButtonType;
	disabled: boolean;
	onClick: () => void;
}
export const ButtonStyled = styled(SimpleButton)<IButtonStyled>`
	min-height: 40px;
	justify-content: center;
	background-color: ${(props) => props.theme.color.endeavour};
	text-align: center;
	box-shadow: none;
	border: none;
	cursor: pointer;
	color: ${({ theme }) => theme.color.white};

	&:last-child {
		margin-bottom: 0;
	}
	&:hover {
		background-color: ${({ theme }) => theme.color.bostonBlue};
	}
	&:active {
		background-color: ${({ theme }) => theme.color.congressBlue};
	}
	${({ buttonType, theme }) => {
		switch (buttonType) {
			case 'secondary':
				return css`
					color: ${theme.color.ebony};
					background-color: ${theme.color.porcelainSecond};
					&:hover {
						color: ${theme.color.abbey};
						background-color: ${theme.color.porcelainSecondLight};
					}
					&:active {
						background-color: ${theme.color.ironSecond};
					}
				`;
			case 'tiny':
				return css`
					width: auto;
					min-height: 32px;
					padding: 6px 16px;
					box-sizing: border-box;
					font-size: 14px;
					color: ${theme.color.cyprus};
					background-color: ${theme.color.hokeyPokey};
					&:hover {
						background-color: ${theme.color.hokeyPokeyLight};
					}
					&:active {
						background-color: ${theme.color.anzac};
					}
				`;

			case 'back':
				return css`
					background: none;
					justify-content: initial;
					padding: 0;
					min-height: unset;
					color: ${theme.color.casper};
					width: auto;
					img {
						width: 25px;
						filter: invert(68%) sepia(13%) saturate(348%) hue-rotate(155deg) brightness(91%) contrast(94%);
					}
					&:hover {
						color: ${theme.color.abbey};
						background-color: unset;
						img {
							filter: invert(31%) sepia(10%) saturate(313%) hue-rotate(155deg) brightness(96%) contrast(87%);
						}
					}
					&:active {
						color: ${theme.color.jumbo};
						background-color: unset;
						img {
							filter: invert(49%) sepia(0%) saturate(5%) hue-rotate(29deg) brightness(99%) contrast(83%);
						}
					}
					&:disabled {
						color: ${theme.color.porcelain};
						background-color: unset !important;
						img {
							color: ${theme.color.porcelain};
						}
					}
				`;
			default:
				return '';
		}
	}}
	img {
		color: ${({ theme }) => theme.color.casper};
		margin-right: 3px;
	}

	&:disabled {
		background-color: ${({ theme }) => theme.color.porcelain};
		color: ${({ theme }) => theme.color.casper};
		cursor: not-allowed;
	}
`;
